const { InnerBlocks, useBlockProps } = wp.blockEditor;

export default ({ attributes, className }) => {
    const { imageWidth, imageHeight, imageOffset, isImageAbsolute, hasImageOnRight, gap } = attributes;

    const classes = [
        isImageAbsolute ? 'ImageText-absolute' : '',
        imageOffset !== 0 ? 'ImageText-has-offset' : '',
        hasImageOnRight ? 'ImageText-has-image-on-right' : '',
        className
    ].filter(className => className).join(' ');

    return (
        <div {...useBlockProps.save()} className={`ImageText ${ classes }`} data-width={imageWidth} data-height={imageHeight} data-offset={imageOffset}>
            <div className="ImageText-wrapper Container" style={{ gap: `${gap}px` }}>
                <InnerBlocks.Content />
            </div>
        </div>
    );
}
